export const MICROSITE_NAME_CONTROL = 'microsite-name-control';
export const MICROSITE_NAME_REQUIRED_ERROR = 'microsite-name-required-error';
export const MICROSITE_NAME_REQUIRED_MESSAGE = 'Microsite Name is required field';

export const MICROSITE_LOGO_CONTROL = 'microsite-logo-control';
export const MICROSITE_LOGO_REQUIRED_ERROR = 'microsite-logo-required-error';
export const MICROSITE_LOGO_REQUIRED_MESSAGE = 'Microsite Logo is required field';
export const MICROSITE_LOGO_TO_BIG_MESSAGE = 'Maximum upload size exceeded. Maximum size is 10 MB';
export const MICROSITE_LOGO_TO_BIG_ERROR = 'microsite-logo-to-big-error';

export const MICROSITE_DOMAINS_CONTROL = 'microsite-domains-control';
export const MICROSITE_DOMAINS_REQUIRED_ERROR = 'microsite-domains-required-error';
export const MICROSITE_DOMAINS_REQUIRED_MESSAGE = 'Microsite Domain is required field';
export const MICROSITE_DOMAINS_DUPLICATE = 'microsite-domains-duplicate-error';
export const MICROSITE_DOMAINS_DUPLICATE_MESSAGE = 'This domain is already defined';
export const MICROSITE_DOMAINS_EXISTS = 'microsite-domains-exists-error';

